import * as React from "react";
import { useRouteMatch } from "react-router-dom";
import { TrackingEventLogList } from "./trackingEventLogList";
import { TrackingOperationLogList } from "./trackingOperationLogList";

export const TrackingMain = () => {
    const isOperationLog = useRouteMatch({ path: "/tracking/operationlog", exact: true });

    return (
        <div>
            <div className="row mainContent trackingMain">
                <div className="col-12">
                    <div className="backgroundBoard">
                        <div className="panel">
                            {isOperationLog
                                ? <TrackingOperationLogList />
                                : <TrackingEventLogList />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
